import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientGfrActivities(id: string | undefined) {
  return useQuery(queries.patients.getPatientGfrActivitiesById(id || ''))
}
